<script lang="ts" setup>
defineProps({
  count: {
    default: 0,
    type: Number,
  },
  perPage: {
    required: true,
    type: Number,
  },
})

const emit = defineEmits<{
  pageChange: [page: number]
}>()

const currentPage = defineModel<number>({ required: true })

function onUpdate($event: any) {
  window.scrollTo({
    behavior: 'instant',
    top: 0,
  })

  emit('pageChange', $event)
}
</script>

<template>
  <div class="mt-6 flex select-none justify-center py-4 md:py-6">
    <UPagination
      v-model="currentPage"
      :max="5"
      :next-button="{ icon: getIcon('arrowRight'), trailing: true }"
      :page-count="perPage"
      :prev-button="{ icon: getIcon('arrowLeft') }"
      size="md"
      :total="count"
      :ui="{ rounded: 'h-[40px]' }"
      @update:model-value="onUpdate"
    />
  </div>
</template>
